function datePicker() {
  $('.js_datepicker').datepicker({
    minDate: '+2d',
    maxDate: '+2m +2d',
    showOtherMonths: true,
    selectOtherMonths: true,
    dateFormat: 'yy/mm/dd',
    beforeShow: function () {
      setTimeout(function () {
        $('.ui-datepicker').css('z-index', 10);
      }, 0);
    },
    beforeShowDay: function (date) {
      const holidayEl = document.getElementById('holiday_data');
      const DateRaw = holidayEl.dataset.roppongiDate || '';
      const RegularHoliday = holidayEl.dataset.roppongiRegularHoliday || '';
      let Dates = [];
      try {
        Dates = JSON.parse(DateRaw);
      } catch (e) {
        Dates = DateRaw.split(/,|\n/).map(d => d.trim()).filter(Boolean);
      }
      const DateArray = Dates.map(d => {
        const [y, m, day] = d.split('-').map(Number);
        return [y, m, day];
      });
      // デフォルトで六本木のカレンダー
      if (RegularHoliday.includes(date.getDay())) {
        return [false, 'ui-state-disabled'];
      }
      for (let i = 0; i < DateArray.length; i++) {
        const d = DateArray[i];
        if (d[0] === date.getFullYear() && d[1] === date.getMonth() + 1 && d[2] === date.getDate()) {
          return [false, 'ui-state-disabled'];
        }
      }
      return [true, ''];
    },
    onSelect: function (dateText, inst) {
      timeSelect.selectedIndex = 0;
      timeSelect.classList.remove('is-selected');
    },
  });
}
datePicker();

// 日付の直接入力を許可しない
$('.js_datepicker').on('keydown', function (e) {
  // 半角文字
  if (e.keyCode != 9) {
    // Tabキーは除く
    e.preventDefault();
  }
});
$('.js_datepicker').on('change', function (e) {
  // 全角文字
  if ($(this).val().match(/[^0-9\/]/)) {
    $(this).val('');
  }
});

const showroomSelect = document.getElementById('showroom_select');
const dateSelect = $('#date');
const timeSelect = document.getElementById('time');

// 店舗別表示カレンダーの設定
$('select#showroom_select').change(function () {
  const storeSelected = document.getElementById('showroom_select').value;

  $('#date').datepicker('setDate', null);
  timeSelect.selectedIndex = 0;
  timeSelect.classList.remove('is-selected');

  if ($(this).val() == 'コントラクト（南青山）ショールーム') {
    {
      $('#date').datepicker('setDate', null);
      const holidayEl = document.getElementById('holiday_data');
      const DateRaw = holidayEl.dataset.minamiAoyamaDate || '';
      const RegularHoliday = holidayEl.dataset.minamiAoyamaRegularHoliday || '';
      let Dates = [];
      try {
        Dates = JSON.parse(DateRaw);
      } catch (e) {
        Dates = DateRaw.split(/,|\n/).map(d => d.trim()).filter(Boolean);
      }
      const DateArray = Dates.map(d => {
        const [y, m, day] = d.split('-').map(Number);
        return [y, m, day];
      });
      $('.js_datepicker').datepicker('option', 'beforeShowDay', function (date) {
        if (RegularHoliday.includes(date.getDay())) {
          return [false, 'ui-state-disabled'];
        }
        for (let i = 0; i < DateArray.length; i++) {
          const d = DateArray[i];
          if (d[0] === date.getFullYear() && d[1] === date.getMonth() + 1 && d[2] === date.getDate()) {
            return [false, 'ui-state-disabled'];
          }
        }
        return [true, ''];
      });
    }
  } else if ($(this).val() == '大阪ショールーム') {
    {
      $('#date').datepicker('setDate', null);
      const holidayEl = document.getElementById('holiday_data');
      const DateRaw = holidayEl.dataset.osakaDate || '';
      const RegularHoliday = holidayEl.dataset.osakaRegularHoliday || '';
      let Dates = [];
      try {
        Dates = JSON.parse(DateRaw);
      } catch (e) {
        Dates = DateRaw.split(/,|\n/).map(d => d.trim()).filter(Boolean);
      }
      const DateArray = Dates.map(d => {
        const [y, m, day] = d.split('-').map(Number);
        return [y, m, day];
      });
      $('.js_datepicker').datepicker('option', 'beforeShowDay', function (date) {
        if (RegularHoliday.includes(date.getDay())) {
          return [false, 'ui-state-disabled'];
        }
        for (let i = 0; i < DateArray.length; i++) {
          const d = DateArray[i];
          if (d[0] === date.getFullYear() && d[1] === date.getMonth() + 1 && d[2] === date.getDate()) {
            return [false, 'ui-state-disabled'];
          }
        }
        return [true, ''];
      });
    }
  } else if ($(this).val() == 'オンラインミーティング') {
    {
      $('#date').datepicker('setDate', null);
      const holidayEl = document.getElementById('holiday_data');
      const DateRaw = holidayEl.dataset.osakaDate || '';
      const RegularHoliday = holidayEl.dataset.osakaRegularHoliday || '';
      let Dates = [];
      try {
        Dates = JSON.parse(DateRaw);
      } catch (e) {
        Dates = DateRaw.split(/,|\n/).map(d => d.trim()).filter(Boolean);
      }
      const DateArray = Dates.map(d => {
        const [y, m, day] = d.split('-').map(Number);
        return [y, m, day];
      });
      $('.js_datepicker').datepicker('option', 'beforeShowDay', function (date) {
        if (RegularHoliday.includes(date.getDay())) {
          return [false, 'ui-state-disabled'];
        }
        for (let i = 0; i < DateArray.length; i++) {
          const d = DateArray[i];
          if (d[0] === date.getFullYear() && d[1] === date.getMonth() + 1 && d[2] === date.getDate()) {
            return [false, 'ui-state-disabled'];
          }
        }
        return [true, ''];
      });
    }
  } else if ($(this).val() == '六本木ショールーム') {
    {
      $('#date').datepicker('setDate', null);
      const holidayEl = document.getElementById('holiday_data');
      const DateRaw = holidayEl.dataset.roppongiDate || '';
      const RegularHoliday = holidayEl.dataset.roppongiRegularHoliday || '';
      let Dates = [];
      try {
        Dates = JSON.parse(DateRaw);
      } catch (e) {
        Dates = DateRaw.split(/,|\n/).map(d => d.trim()).filter(Boolean);
      }
      const DateArray = Dates.map(d => {
        const [y, m, day] = d.split('-').map(Number);
        return [y, m, day];
      });
      $('.js_datepicker').datepicker('option', 'beforeShowDay', function (date) {
        if (RegularHoliday.includes(date.getDay())) {
          return [false, 'ui-state-disabled'];
        }
        for (let i = 0; i < DateArray.length; i++) {
          const d = DateArray[i];
          if (d[0] === date.getFullYear() && d[1] === date.getMonth() + 1 && d[2] === date.getDate()) {
            return [false, 'ui-state-disabled'];
          }
        }
        return [true, ''];
      });
    }
  } else if ($(this).val() == '東京ショールーム') {
    {
      $('#date').datepicker('setDate', null);
      const holidayEl = document.getElementById('holiday_data');
      const DateRaw = holidayEl.dataset.tokyoDate || '';
      const RegularHoliday = holidayEl.dataset.tokyoRegularHoliday || '';
      let Dates = [];
      try {
        Dates = JSON.parse(DateRaw);
      } catch (e) {
        Dates = DateRaw.split(/,|\n/).map(d => d.trim()).filter(Boolean);
      }
      const DateArray = Dates.map(d => {
        const [y, m, day] = d.split('-').map(Number);
        return [y, m, day];
      });
      $('.js_datepicker').datepicker('option', 'beforeShowDay', function (date) {
        if (RegularHoliday.includes(date.getDay())) {
          return [false, 'ui-state-disabled'];
        }
        for (let i = 0; i < DateArray.length; i++) {
          const d = DateArray[i];
          if (d[0] === date.getFullYear() && d[1] === date.getMonth() + 1 && d[2] === date.getDate()) {
            return [false, 'ui-state-disabled'];
          }
        }
        return [true, ''];
      });
    }
  }

});
